import { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import Modal from "../common/UI/Modal/Modal";
import { Button, Text } from "../common/UI";
import { useTheme } from "styled-components";
import closeMsgImg from "../assets/img/close.svg";
import { useTranslation } from "react-i18next";

const SuccesScreen = ({ productsStore }) => {
  const [showModal, setShowModal] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation("deliveryOrder");

  useEffect(() => {
    if (!!productsStore.orderConfirmed) {
      setShowModal(true);
      productsStore.setOrderConfirmed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsStore.orderConfirmed]);

  return (
    <div>
      {showModal && (
        <Modal onClose={() => setShowModal(false)} show={showModal}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "72vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <Text.SemiBold
                size={16}
                color={theme.color.text}
                style={{
                  paddingTop: 12,
                  marginBottom: 20,
                }}
              >
                {t("deliveryOrder:title_success")}
              </Text.SemiBold>
              <img
                onClick={() => setShowModal(false)}
                alt="closeMsgImg"
                src={closeMsgImg}
                style={{
                  width: 24,
                  height: 24,
                  position: "absolute",
                  left: 45,
                  cursor: "pointer",
                }}
              />
            </div>
            <Text.Medium
              size={15}
              color={theme.color.text}
              style={{ marginTop: 42, marginBottom: 10 }}
            >
              {t("deliveryOrder:thanks")}
            </Text.Medium>
            <Text.Medium size={15} color={theme.color.text} style={{ marginBottom: 20 }}>
              {t("deliveryOrder:order_sent_succesfully")}
            </Text.Medium>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 44,
                width: "110px",
              }}
            >
              <Button
                onClick={() => setShowModal(false)}
                style={{
                  margin: 10,
                  height: 32,
                  lineHeight: "0px",
                  fontSize: 14,
                  border: `2px solid ${theme.color.red}`,
                }}
              >
                {t("close")}
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default inject("productsStore")(observer(SuccesScreen));
